import React, { useState } from "react";
import { Box, Typography, Paper, Button as MuiButton } from "@mui/material";
import { useDropzone } from "react-dropzone";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { createExcelTemplate } from "./template";
import Button from "../../../common/Button";

const AddCSV = ({
  handleNextStep,
  handleBackStep,
  csvData,
  handleDrop,
  file,
}) => {
  const [download, setDownload] = useState(false);

  // File is uploaded status
  const isFileUploaded = file !== null && csvData.length > 0;

  // Custom onDrop handler that ensures the input is always enabled for re-uploads
  const onDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      handleDrop(acceptedFiles);
    }
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    noClick: isFileUploaded, // Disable click when file is uploaded to prevent accidental clicks
    noKeyboard: isFileUploaded,
  });

  // Handler to clear the current file and allow for a new upload
  const handleClearFile = (e) => {
    e.stopPropagation(); // Prevent triggering the dropzone click
    // Signal to the parent component that the file should be cleared
    handleDrop(null);
  };

  return (
    <div>
      <div>
        <Button
          onClick={() => {
            createExcelTemplate();
            setDownload(true);
          }}
          text={"Download Template"}
        />
        <Box
          sx={{
            pointerEvents: download ? "auto" : "none",
            opacity: download ? 1 : 0.5,
            mt: 3,
          }}
        >
          <div
            {...getRootProps()}
            style={{
              border: "1px dashed gray",
              padding: "20px",
              marginTop: "20px",
              color: download ? "black" : "gray",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: download && !isFileUploaded ? "pointer" : "default",
              backgroundColor: isFileUploaded ? "#f0f7ff" : "transparent",
              position: "relative",
            }}
          >
            <input {...getInputProps()} />

            {isFileUploaded ? (
              <>
                <CheckCircleIcon
                  style={{ color: "#4caf50", fontSize: 40, marginBottom: 10 }}
                />
                <Typography
                  variant="body1"
                  style={{ fontWeight: "500", marginBottom: 5 }}
                >
                  File uploaded successfully
                </Typography>
                <Paper
                  elevation={1}
                  style={{
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 10,
                    backgroundColor: "#e8f4ff",
                    width: "80%",
                    maxWidth: "350px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <InsertDriveFileIcon
                      style={{ marginRight: 10, color: "#1976d2" }}
                    />
                    <Typography variant="body2">
                      {file?.name} ({csvData.length} users)
                    </Typography>
                  </div>
                  <MuiButton
                    size="small"
                    style={{ minWidth: "auto", padding: "4px" }}
                    onClick={handleClearFile}
                  >
                    <DeleteOutlineIcon fontSize="small" color="error" />
                  </MuiButton>
                </Paper>

                <div style={{ marginTop: 20, display: "flex", gap: 8 }}>
                  <MuiButton
                    variant="outlined"
                    size="small"
                    startIcon={<UploadFileIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      open();
                    }}
                    style={{ textTransform: "none" }}
                  >
                    Upload another file
                  </MuiButton>
                </div>
              </>
            ) : (
              <>
                <UploadFileIcon style={{ fontSize: 40, marginBottom: 10 }} />
                <Typography variant="body1">
                  Drag and drop or click to upload a CSV file
                </Typography>
              </>
            )}
          </div>
        </Box>
      </div>

      <div style={{ display: "flex", flexDirection: "column", marginTop: 16 }}>
        <Button
          variant="contained"
          onClick={() => {
            handleNextStep();
          }}
          disabled={!csvData.length}
          text={isFileUploaded ? "Continue" : "Upload CSV file"}
        />
        <Button
          variant="outlined"
          onClick={handleBackStep}
          text="Back"
          backgroundColor="white"
        />
      </div>
    </div>
  );
};

export default AddCSV;
